import { render, staticRenderFns } from "./Pdf.vue?vue&type=template&id=6210f08f"
import script from "./Pdf.vue?vue&type=script&lang=js"
export * from "./Pdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports